import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "react-app-polyfill/stable";
import reportWebVitals from "./utils/reportWebVitals";
import App from "./App";
import "react-medium-image-zoom/dist/styles.css";
import { ThemeProvider } from "./contexts/ThemeContext";

// в src/index.tsx или App.tsx
import "./assets/fonts/fonts.css";

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
